/**
 * Beta-app (main CoinTracking) URL utilities
 */

/**
 * Get the beta-app URL by removing .basic subdomain from current domain
 * Examples:
 * - basic.cointracking.info → https://cointracking.info
 * - basic.staging.cointracking.info → https://staging.cointracking.info
 * - localhost:5175 → http://localhost:8000 (fallback for dev)
 */
export const getBetaAppUrl = (): string => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;

    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost:8000';
    }

    if (hostname.startsWith('basic.')) {
        const mainDomain = hostname.replace('basic.', '');
        return `${protocol}//${mainDomain}`;
    }
    return `${protocol}//${hostname}`;
};

/**
 * Get the full URL for beta-app login page
 */
export const getBetaAppLoginUrl = (): string => {
    return `${getBetaAppUrl()}/basic_account.php`;
};

/**
 * Get the full URL for beta-app signup page
 */
export const getBetaAppSignupUrl = (): string => {
    return `${getBetaAppUrl()}/signup.php`;
};

/**
 * Get the full URL for beta-app settings page
 * @param queryParams - Optional query parameters (e.g., '?delete=true')
 */
export const getBetaAppSettingsUrl = (queryParams?: string): string => {
    const baseUrl = `${getBetaAppUrl()}/settings.php`;
    return queryParams ? `${baseUrl}${queryParams}` : baseUrl;
};

/**
 * Get the full URL for beta-app logout page
 */
export const getBetaAppLogoutUrl = (): string => {
    return `${getBetaAppUrl()}/logout.php`;
};

